<fui-panels>
    <fui-panel class="panel">
        <ng-template #panelcontent>
            <div class="panel-content">
                <div class="trees">
                    <fui-trees #unselectedTreeComponent id="unselectedTreeComponent"
                               [trees]="unselectedTreesData">
                        <ng-template #treesheader>
                            <div class="trees-header">
                                <div class="trees-header-label">
                                    <div class="trees-header-label-title">
                                        {{"wbo.localisation.heading.availableOutlets" | translate}}
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template #treeheadercontext let-tree="tree">
                            <div class="tree-header-context-action" (click)="selectItem(tree, true)" *ngIf="!readonly">
                                <fui-context-button [title]="'wbo.common.button.add'">
                                    <fui-icon [height]="8" [icon]="'plus'" [width]="8"></fui-icon>
                                </fui-context-button>
                            </div>
                        </ng-template>
                    </fui-trees>
                    <div class="trees-messages" *ngIf="!unselectedTreesData?.length">
                        <div class="trees-messages-message">
                            <div class="trees-messages-message-label">
                                <div class="trees-messages-message-label-title">
                                    {{"wbo.localisation.message.allOutletsSelected" | translate}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </fui-panel>
    <fui-panel class="panel utility theme-alabaster">
        <ng-template #panelcontent>
            <div class="panel-content">
                <div class="trees">
                    <fui-trees #selectedTreeComponent id="selectedTreeComponent"
                               [trees]="selectedTreesData">
                        <ng-template #treesheader>
                            <div class="trees-header">
                                <div class="trees-header-label">
                                    <div class="trees-header-label-title">
                                        {{"wbo.localisation.heading.selectedOutlets" | translate}}
                                    </div>
                                </div>
                                <div class="trees-header-action" *ngIf="!readonly">
                                    <fui-context-button class="utility theme-bright-grey" (click)="resetSelectedOutlets()" [title]="'wbo.localisation.button.resetOutletRestrictions'"></fui-context-button>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template #treeheadercontext let-tree="tree">
                            <div class="tree-header-context-action" (click)="selectItem(tree, false)" *ngIf="!readonly">
                                <fui-context-button [title]="'wbo.common.button.remove'">
                                    <fui-icon [height]="2" [icon]="'remove'" [width]="8"></fui-icon>
                                </fui-context-button>
                            </div>
                        </ng-template>
                    </fui-trees>
                    <div class="trees-messages" *ngIf="!selectedTreesData?.length">
                        <div class="trees-messages-message">
                            <div class="trees-messages-message-label">
                                <div class="trees-messages-message-label-title">
                                    {{"wbo.localisation.message.noOutletsSelected" | translate}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </fui-panel>
</fui-panels>
